import { FooterLayout, useViewport } from '@farmersdog/corgi-x';
import { paths } from '@farmersdog/constants';
import { LINK_PRIVACY_OPTOUT } from '@farmersdog/constants/links';
interface LegalLink {
  label: string;
  props: {
    to?: string;
    href?: string;
  };
}

const links: LegalLink[] = [
  {
    label: 'Privacy',
    props: {
      to: paths.PATH_PRIVACY,
    },
  },
  {
    label: 'Terms',
    props: {
      to: paths.PATH_TERMS,
    },
  },
  {
    label: 'Accessibility',
    props: {
      to: paths.PATH_ACCESSIBILITY,
    },
  },
  {
    label: 'Do Not Sell My Personal Information',
    props: {
      href: LINK_PRIVACY_OPTOUT,
    },
  },
];

export const LegalLinks = () => {
  const viewport = useViewport();
  const isMobile = !viewport.lg;

  return (
    <FooterLayout.LinksList
      direction={isMobile ? 'column' : 'row'}
      aria-label="Legal details"
    >
      {links.map(link => (
        <FooterLayout.LinkItem key={link.label} {...link.props}>
          {link.label}
        </FooterLayout.LinkItem>
      ))}
    </FooterLayout.LinksList>
  );
};
